import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { GrocyContextDataApi } from '../../../../../core/api/grocy/context-data.api';
import { GrocyStockApi } from '../../../../../core/api/grocy/stock.api';
import { GrocyCurrentStock } from '../../../../../core/entities/grocy/stock/current-stock.entity';
import { StockFilterForm } from '../../../stock/forms/stock-filter.form';
import { StockOverview } from '../../../stock/models/stock-overview.model';

@Component({
  selector: 'app-grocy-current-stock',
  templateUrl: './current-stock.component.html',
  styleUrl: './current-stock.component.scss',
})
export class CurrentStockComponent implements OnInit {
  @ViewChild(MatSort) sort!: MatSort;

  currentStock: GrocyCurrentStock[] = [];
  dataSource!: MatTableDataSource<GrocyCurrentStock>;
  form?: StockFilterForm;
  loading = true;

  constructor(
    private contextDataApi: GrocyContextDataApi,
    private stockApi: GrocyStockApi
  ) {}

  ngOnInit(): void {
    this.loadStock();
  }

  get overview(): StockOverview {
    return {
      numberOfExpiredProducts: this.dataSource.data.filter(item => item.stockCategory === 'Expired').length,
      numberOfExpiringProducts: this.dataSource.data.filter(item => item.stockCategory === 'Expiring Soon').length,
      numberOfOpenedProducts: this.dataSource.data.filter(item => item.amountOpened > 0).length,
      numberOfOutOfStockProducts: this.dataSource.data.filter(item => item.stockCategory === 'Low Stock').length,
      numberOfProducts: this.dataSource.data.length,
      totalValue: this.dataSource.data.reduce((acc, item) => acc + item.value, 0),
    };
  }

  applyFilter(): void {
    if (!this.form) return;
    this.dataSource.data = this.form.filterStock(this.currentStock);
  }

  changeSelection(stockCategory: string | null) {
    switch (stockCategory) {
      case 'Opened':
        this.dataSource.filterPredicate = (data, filter) => (data.amountOpened > 0 ? 'opened' : 'closed') === filter;
        this.dataSource.filter = 'opened';
        break;
      case null:
        this.dataSource.filterPredicate = () => true;
        this.dataSource.filter = '';
        break;
      default:
        this.dataSource.filterPredicate = data => data.stockCategory === stockCategory;
        this.dataSource.filter = stockCategory;
        break;
    }
  }

  private loadStock(): void {
    forkJoin({
      contextData: this.contextDataApi.getContextData(),
      currentStock: this.stockApi.findCurrent(),
    }).subscribe(({ contextData, currentStock }) => {
      this.currentStock = currentStock;
      this.dataSource = new MatTableDataSource(currentStock);
      this.form = new StockFilterForm(contextData);
      this.form.formGroup.valueChanges.subscribe(() => this.applyFilter());
      this.loading = false;
    });
  }
}
